import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.modal');
import { OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, HostListener, AfterViewChecked, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-modal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.modal/view.scss */
:host {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  pointer-events: none;
}

:host > div {
  pointer-events: auto;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes slideDown {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(1rem);
    opacity: 0;
  }
}
.modal-icon-bg {
  background-color: var(--brand-light, #FFF6F3);
}

.modal-icon-color {
  color: var(--brand, #FE5733);
}

.modal-btn-primary {
  background-color: var(--brand, #FE5733);
}`],
})
export class ComponentModalComponent implements OnInit, AfterViewChecked, OnChanges, OnDestroy {
    @Input() isOpen: boolean = false;
    @Input() mode: string = 'info';
    @Input() title: string = '';
    @Input() playerData: any = null;
    @Input() recipientName: string = '';
    @Input() recipientLocked: boolean = true;
    @Input() currentColor: string = '#4F8EF7';
    @Input() incomingNote: any = null;
    @Input() sentNoteData: any = null;
    @Input() players: Array<{ sid: string, nickname: string, color?: string }> = [];
    @Input() webinarRoomName: string = '';
    @Input() webinarError: string = '';
    @Input() webinarJoining: boolean = false;

    @Output() modalClose = new EventEmitter<void>();
    @Output() noteSend = new EventEmitter<any>();
    @Output() colorSelect = new EventEmitter<string>();
    @Output() noteReply = new EventEmitter<any>();
    @Output() myInfoSave = new EventEmitter<any>();
    @Output() whisperTargetSelected = new EventEmitter<any>();
    @Output() logoutConfirm = new EventEmitter<void>();
    @Output() centerSwitchConfirm = new EventEmitter<string>();
    @Output() deleteConfirm = new EventEmitter<void>();
    @Output() statusConfirm = new EventEmitter<void>();
    @Output() webinarJoin = new EventEmitter<{ stream?: MediaStream, error?: string }>();

    @Input() centerSwitchTarget: string = '';
    @Input() statusConfirmTarget: string = '';
    @Input() intranetStatus: string = 'in';

    public isClosing: boolean = false;
    public isEditing: boolean = false;
    public editNickname: string = '';
    public editShape: string = 'circle';
    private savedOverflow: string = '';

    public shapeOptions = [
        { value: 'circle', label: '원', icon: 'fa-circle' },
        { value: 'square', label: '사각형', icon: 'fa-square' },
        { value: 'triangle', label: '삼각형', icon: 'fa-play fa-rotate-270' },
        { value: 'heart', label: '하트', icon: 'fa-heart' },
        { value: 'star', label: '별', icon: 'fa-star' },
    ];

    @ViewChild('colorCanvas') colorCanvasRef!: ElementRef<HTMLCanvasElement>;
    @ViewChild('hueCanvas') hueCanvasRef!: ElementRef<HTMLCanvasElement>;

    constructor(@Inject( Service) public service: Service) { }

    public noteText: string = '';
    public selectedTargetSid: string = '';
    public searchText: string = '';
    public hexInput: string = '#4F8EF7';
    public previewColor: string = '#4F8EF7';
    private hue: number = 210;
    private sat: number = 0.75;
    private val: number = 0.97;
    private colorCanvasDrawn: boolean = false;
    private isDraggingColor: boolean = false;
    private isDraggingHue: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['isOpen']) {
            if (changes['isOpen'].currentValue) {
                this.savedOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = this.savedOverflow;
            }
        }
    }

    public ngOnDestroy() {
        document.body.style.overflow = this.savedOverflow;
    }

    public ngAfterViewChecked() {
        if (this.isOpen && (this.mode === 'colorpicker' || (this.mode === 'myinfo' && this.isEditing)) && !this.colorCanvasDrawn) {
            if (this.colorCanvasRef && this.hueCanvasRef) {
                this.initColorFromHex(this.currentColor);
                this.drawColorCanvas();
                this.drawHueCanvas();
                this.colorCanvasDrawn = true;
            }
        }
        if (!this.isOpen) {
            this.colorCanvasDrawn = false;
        }
    }

    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.isOpen) {
            event.stopPropagation();
            this.onClose();
        }
    }

    public async onClose() {
        this.isClosing = true;
        await this.service.render();
        setTimeout(() => {
            this.isClosing = false;
            this.noteText = '';
            this.selectedTargetSid = '';
            this.searchText = '';
            this.isEditing = false;
            document.body.style.overflow = this.savedOverflow;
            this.modalClose.emit();
        }, 200);
    }

    public onOverlayClick(event: MouseEvent) {
        // 외부 클릭으로 모달을 닫지 않음 (X 버튼/ESC로만 닫기)
    }

    // === Whisper target ===
    public get filteredPlayers(): Array<{ sid: string, nickname: string, color?: string }> {
        if (!this.searchText?.trim()) return this.players || [];
        const query = this.searchText.trim().toLowerCase();
        return (this.players || []).filter(p => p.nickname.toLowerCase().includes(query));
    }

    public async onSelectWhisperTarget(player: any) {
        this.whisperTargetSelected.emit(player);
        this.searchText = '';
        this.isClosing = true;
        await this.service.render();
        setTimeout(() => {
            this.isClosing = false;
            this.modalClose.emit();
        }, 200);
    }

    // === Note ===
    public async onSendNote() {
        const text = this.noteText.trim();
        if (!text) return;
        if (this.recipientLocked) {
            this.noteSend.emit(text);
        } else {
            if (!this.selectedTargetSid) return;
            this.noteSend.emit({ targetSid: this.selectedTargetSid, message: text });
        }
        this.noteText = '';
        this.selectedTargetSid = '';
    }

    public async onReplyNote() {
        if (this.incomingNote) {
            this.noteReply.emit({
                nickname: this.incomingNote.nickname || this.incomingNote.from || '',
                userId: this.incomingNote.userId || this.incomingNote.fromUserId || '',
            });
        }
    }

    // === My Info ===
    public async startEditing() {
        this.editNickname = this.playerData?.nickname || '';
        this.editShape = this.playerData?.shape || 'circle';
        this.isEditing = true;
        this.colorCanvasDrawn = false;
        await this.service.render();
    }

    public async cancelEditing() {
        this.isEditing = false;
        this.colorCanvasDrawn = false;
        await this.service.render();
    }

    public async onSaveMyInfo() {
        this.myInfoSave.emit({
            nickname: this.editNickname.trim(),
            color: this.hexInput,
            shape: this.editShape,
        });
        this.isEditing = false;
        this.colorCanvasDrawn = false;
    }

    // === Info helpers ===
    public getStatusColor(status: string): string {
        const map: any = { in: '#10B981', away: '#F59E0B', trip: '#3B82F6', vacation: '#A78BFA', out: '#9CA3AF' };
        return map[status] || '#9CA3AF';
    }

    public getStatusLabel(status: string): string {
        const map: any = { in: '출근', away: '자리비움', trip: '출장', vacation: '휴가', out: '퇴근' };
        return map[status] || '알 수 없음';
    }

    // === Note send validity ===
    public get canSendNote(): boolean {
        if (!this.noteText?.trim()) return false;
        if (!this.recipientLocked && !this.selectedTargetSid) return false;
        return true;
    }

    // === Color Picker ===
    private initColorFromHex(hex: string) {
        try {
            const r = parseInt(hex.slice(1, 3), 16) / 255;
            const g = parseInt(hex.slice(3, 5), 16) / 255;
            const b = parseInt(hex.slice(5, 7), 16) / 255;
            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            const d = max - min;
            this.val = max;
            this.sat = max === 0 ? 0 : d / max;
            if (d === 0) { this.hue = 0; }
            else if (max === r) { this.hue = (((g - b) / d) % 6) * 60; }
            else if (max === g) { this.hue = ((b - r) / d + 2) * 60; }
            else { this.hue = ((r - g) / d + 4) * 60; }
            if (this.hue < 0) this.hue += 360;
            this.hexInput = hex;
            this.previewColor = hex;
        } catch (e) { }
    }

    private drawColorCanvas() {
        const canvas = this.colorCanvasRef?.nativeElement;
        if (!canvas) return;
        const ctx = canvas.getContext('2d')!;
        const w = canvas.width;
        const h = canvas.height;
        const hueRgb = this.hsvToRgb(this.hue, 1, 1);
        const gradH = ctx.createLinearGradient(0, 0, w, 0);
        gradH.addColorStop(0, '#FFFFFF');
        gradH.addColorStop(1, `rgb(${hueRgb.r},${hueRgb.g},${hueRgb.b})`);
        ctx.fillStyle = gradH;
        ctx.fillRect(0, 0, w, h);
        const gradV = ctx.createLinearGradient(0, 0, 0, h);
        gradV.addColorStop(0, 'rgba(0,0,0,0)');
        gradV.addColorStop(1, '#000000');
        ctx.fillStyle = gradV;
        ctx.fillRect(0, 0, w, h);
        const sx = this.sat * w;
        const sy = (1 - this.val) * h;
        ctx.beginPath();
        ctx.arc(sx, sy, 6, 0, Math.PI * 2);
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(sx, sy, 7, 0, Math.PI * 2);
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = 1;
        ctx.stroke();
    }

    private drawHueCanvas() {
        const canvas = this.hueCanvasRef?.nativeElement;
        if (!canvas) return;
        const ctx = canvas.getContext('2d')!;
        const w = canvas.width;
        const h = canvas.height;
        const grad = ctx.createLinearGradient(0, 0, w, 0);
        for (let i = 0; i <= 360; i += 30) {
            const rgb = this.hsvToRgb(i, 1, 1);
            grad.addColorStop(i / 360, `rgb(${rgb.r},${rgb.g},${rgb.b})`);
        }
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, w, h);
        const hx = (this.hue / 360) * w;
        ctx.beginPath();
        ctx.rect(hx - 3, 0, 6, h);
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 2;
        ctx.stroke();
    }

    public onColorCanvasDown(event: MouseEvent) {
        this.isDraggingColor = true;
        this.pickColor(event);
    }

    public onColorCanvasMove(event: MouseEvent) {
        if (!this.isDraggingColor) return;
        this.pickColor(event);
    }

    public onHueCanvasDown(event: MouseEvent) {
        this.isDraggingHue = true;
        this.pickHue(event);
    }

    public onHueCanvasMove(event: MouseEvent) {
        if (!this.isDraggingHue) return;
        this.pickHue(event);
    }

    @HostListener('window:mouseup')
    onMouseUp() {
        this.isDraggingColor = false;
        this.isDraggingHue = false;
    }

    private async pickColor(event: MouseEvent) {
        const canvas = this.colorCanvasRef?.nativeElement;
        if (!canvas) return;
        const rect = canvas.getBoundingClientRect();
        const x = Math.max(0, Math.min(canvas.width, (event.clientX - rect.left) * (canvas.width / rect.width)));
        const y = Math.max(0, Math.min(canvas.height, (event.clientY - rect.top) * (canvas.height / rect.height)));
        this.sat = x / canvas.width;
        this.val = 1 - y / canvas.height;
        this.updateColor();
        await this.service.render();
    }

    private async pickHue(event: MouseEvent) {
        const canvas = this.hueCanvasRef?.nativeElement;
        if (!canvas) return;
        const rect = canvas.getBoundingClientRect();
        const x = Math.max(0, Math.min(canvas.width, (event.clientX - rect.left) * (canvas.width / rect.width)));
        this.hue = (x / canvas.width) * 360;
        this.updateColor();
        this.drawColorCanvas();
        await this.service.render();
    }

    private updateColor() {
        const rgb = this.hsvToRgb(this.hue, this.sat, this.val);
        this.hexInput = this.rgbToHex(rgb.r, rgb.g, rgb.b);
        this.previewColor = this.hexInput;
        this.drawColorCanvas();
        this.drawHueCanvas();
    }

    public async onHexChange() {
        if (/^#[0-9a-fA-F]{6}$/.test(this.hexInput)) {
            this.initColorFromHex(this.hexInput);
            this.previewColor = this.hexInput;
            this.drawColorCanvas();
            this.drawHueCanvas();
            await this.service.render();
        }
    }

    public async onConfirmColor() {
        this.colorSelect.emit(this.hexInput);
    }

    // getUserMedia MUST be called directly in the click handler
    // to preserve browser user-gesture (transient activation) context
    public async onWebinarJoinClick() {
        if (!navigator.mediaDevices?.getUserMedia) {
            this.webinarJoin.emit({ error: 'unsupported' });
            return;
        }
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            this.webinarJoin.emit({ stream });
        } catch (e: any) {
            this.webinarJoin.emit({ error: e?.message || 'denied' });
        }
    }

    private hsvToRgb(h: number, s: number, v: number): { r: number, g: number, b: number } {
        const c = v * s;
        const x = c * (1 - Math.abs((h / 60) % 2 - 1));
        const m = v - c;
        let r = 0, g = 0, b = 0;
        if (h < 60) { r = c; g = x; }
        else if (h < 120) { r = x; g = c; }
        else if (h < 180) { g = c; b = x; }
        else if (h < 240) { g = x; b = c; }
        else if (h < 300) { r = x; b = c; }
        else { r = c; b = x; }
        return {
            r: Math.round((r + m) * 255),
            g: Math.round((g + m) * 255),
            b: Math.round((b + m) * 255)
        };
    }

    private rgbToHex(r: number, g: number, b: number): string {
        return '#' + [r, g, b].map(c => c.toString(16).padStart(2, '0')).join('');
    }

}

export default ComponentModalComponent;